import moment from 'moment'
import { last7BusinessDays } from '../common/dateUtils'
import { 
  openJobs, 
  boxDocsForJob, 
  allBoxDocsForJob,
  myJob, 
  unAssignedJobs, 
  todayTransmittedJobs, 
  myJobTransmittedToday,
  getJobsWithQCBoxes
} from '../firestore/gdeJobs'
import { districtMetricsInfo, districtMetricsInfoByWorker } from '../firestore/gdeMetrics'
import {
  ARRAY_LIMIT,
  jobCreated,
  jobAssigned,
  jobStarted,
  boxDeStarted,
  boxReadyForVerify,
  boxVerificationStarted,
  boxReadyForQc,
  boxQcStarted,
  boxReKeyRequired,
  boxReadyForTransmit,
  boxTransmitted,
  deJobCategory,
  exceptionBox,
  readyToTransmit,
  jobTransmitted,
  totalNoOfBoxesForJob
} from '../common/appConstants'
import { roundNumber } from '../../irmlib/src/common'
/**
 * @description this method will capture below data
 * jobs in open status (list of status which consider as open)
 * boxes will be available if the status is InProcess only
 * get all boxes for the jobs which are in  In Process status
 * from the result identify the details ready for verification
 * and ready for QC and submited today
 * (TODO here the assumtion is within the same day job will 
 * not get close and it will remin in In Process status - get confirmation)
 * @param {string} district current district
 * @returns {object} job details
 */
export const currentJobs = async (district) => {
  const services = [
    openJobs(district),
    getTodaysTransmittedJobs(district),
    getJobsWithQCBoxes(district)
  ]
  const result = await Promise.all(services)
  const openJobSnapshot = result[0]
  const transmittedStatusJobs = result[1]
  const JobsWithBoxesInQc = result[2]

  const assignedJobData = []
  const pendingJobData = []
  const inProcessJobData = [] 
  const readyToTransmitData = []
  const TransmitData = []

  const jobList = []
  let totalPendingJobBoxes = 0
  let totalAssignedJobBoxes = 0
  let totalInProcessJobBoxes = 0
  // let totalInReadyToTransmit = 0
  const totalInReadyToTransmit = 0
  const totalInTransmit = 0


  openJobSnapshot.forEach(job => {
    let totBoxForJob = job.data().totalBoxes
    if (totBoxForJob === totalNoOfBoxesForJob) {
      totBoxForJob = 0
    }

    switch (job.data().jobStatus) {
      case jobCreated:
        pendingJobData.push(job)
        totalPendingJobBoxes = totalPendingJobBoxes + parseInt(totBoxForJob)
        break
      case jobAssigned:
        assignedJobData.push(job)
        totalAssignedJobBoxes = totalAssignedJobBoxes + parseInt(totBoxForJob)
        break
      case jobStarted:
        inProcessJobData.push(job)
        totalInProcessJobBoxes = totalInProcessJobBoxes + parseInt(totBoxForJob)
        jobList.push(job.id)
        break
      case readyToTransmit:
        readyToTransmitData.push(job)
        totalInProcessJobBoxes = totalInReadyToTransmit + parseInt(totBoxForJob)
        jobList.push(job.id)
        break
      case jobTransmitted:
        TransmitData.push(job)
        totalInProcessJobBoxes = totalInTransmit + parseInt(totBoxForJob)
        jobList.push(job.id)
        break
    }    
  })
  
  if (transmittedStatusJobs.size > 0) {    
    transmittedStatusJobs.forEach(job => {
      jobList.push(job.id)
    })
  }
  const boxLevelInfo = await getBoxLevelInfo(district, jobList)

  const currentDistrictJobInfo = {
    jobInfo: {
      numOfOpenJobs: openJobSnapshot.size,
      numOfPendingJobs: pendingJobData.length,
      numberOfAssignedJobs: assignedJobData.length,
      numOfInProcessJobs: inProcessJobData.length,
      numOfInReadytoTransmit: readyToTransmitData.length,
      numOfQualityCheckJobs: JobsWithBoxesInQc.length
    },
    boxLevelInfo: {
      numOfBoxesDataEntryInProcess: boxLevelInfo.numOfBoxDataEntryInProcess,
      numOfBoxesReadyForVerify: boxLevelInfo.numOfBoxReadyForVerify,
      numOfBoxesVerificationInProcess: boxLevelInfo.numOfBoxVerificationInProcess,
      numOfBoxesReadyForQc: boxLevelInfo.numOfBoxesReadyForQc,
      numOfBoxesQcInProcess: boxLevelInfo.numOfBoxesQcInProcess,
      numOfBoxesReqReKey: boxLevelInfo.numOfBoxesReqReKey,
      numOfBoxesException: boxLevelInfo.numOfBoxesException,
      numbOfBoxesReadyForTransmit: boxLevelInfo.numbOfBoxesReadyForTransmit,
      numOfBoxesTransmitted: boxLevelInfo.numOfBoxesTransmitted,
      numOfBoxesSubmittedToday: boxLevelInfo.numOfBoxesSubmittedToday

    }    
  }
  return currentDistrictJobInfo
}

const getTodayUtcDateTs = () => {
  const startTodaylocalDateTs = new Date(moment(new Date()).format('YYYY-MM-DDT00:00:00'))  
  const endTodaylocalDateTs = new Date(moment(new Date()).format('YYYY-MM-DDT23:59:59'))
  const startUtcDateTs = moment(startTodaylocalDateTs).utc().format('YYYY-MM-DDTHH:mm:ss')
  const endUtcDateTs = moment(endTodaylocalDateTs).utc().format('YYYY-MM-DDTHH:mm:ss')
  return {
    startUtcDateTs,
    endUtcDateTs
  }
}

const getTodaysTransmittedJobs = async district => {
  const { startUtcDateTs, endUtcDateTs } = getTodayUtcDateTs()
  const transmittedStatusJobs = await todayTransmittedJobs(district, startUtcDateTs, endUtcDateTs)
  return transmittedStatusJobs
}

/**
 * @description this method will pull box level information
 * @param {string} district district id 
 * @param {object} jobList box level information 
 * @returns {object} box level counts and related job info
 */
async function getBoxLevelInfo(district, jobList) {
  const { startUtcDateTs, endUtcDateTs } = getTodayUtcDateTs()
  let numOfBoxesReadyForVerify = 0
  let numOfBoxesReadyForQc = 0
  let numOfBoxesSubmittedToday = 0
  let numOfBoxesDataEntryInProcess = 0 
  let numOfBoxesVerificationInProcess = 0
  let numOfBoxesQcInProcess = 0
  let numOfBoxesReqReKey = 0
  let numOfBoxesException = 0
  let numbOfBoxesReadyForTransmit = 0
  let numOfBoxesTransmitted = 0
  
  const services = []
  for (let i = 0; i < jobList.length; i += ARRAY_LIMIT) {
    const jobSubList = jobList.slice(i, i + ARRAY_LIMIT)
    services.push(boxDocsForJob(district, jobSubList))
  }

  const result = await Promise.all(services)
  for (let i = 0; i < result.length; ++i) {
    const boxResults = result[i]
    boxResults.forEach(box => {
      switch (box.data().status) {
        case boxDeStarted:
          numOfBoxesDataEntryInProcess++
          break         
        case boxReadyForVerify:
          numOfBoxesReadyForVerify++ 
          break
        case boxVerificationStarted:
          numOfBoxesVerificationInProcess++
          break
        case boxReadyForQc:
          numOfBoxesReadyForQc++          
          break
        case boxQcStarted:
          numOfBoxesQcInProcess++
          break      
        case boxReKeyRequired:
          numOfBoxesReqReKey++
          break
        case exceptionBox:
          numOfBoxesException++
          break
        case boxReadyForTransmit:
          numbOfBoxesReadyForTransmit++
          break
        case boxTransmitted:
          numOfBoxesTransmitted++
          if (box.data().transmittedTs && (startUtcDateTs <= box.data().transmittedTs.toDate() || 
          endUtcDateTs >= box.data().transmittedTs.toDate())) {
            numOfBoxesSubmittedToday++           
          }
          break
      }
    })
  }
  return {
    numOfBoxDataEntryInProcess: numOfBoxesDataEntryInProcess,
    numOfBoxReadyForVerify: numOfBoxesReadyForVerify,
    numOfBoxVerificationInProcess: numOfBoxesVerificationInProcess,
    numOfBoxesReadyForQc: numOfBoxesReadyForQc,
    numOfBoxesQcInProcess: numOfBoxesQcInProcess,
    numOfBoxesReqReKey: numOfBoxesReqReKey,
    numOfBoxesException: numOfBoxesException,
    numbOfBoxesReadyForTransmit: numbOfBoxesReadyForTransmit,
    numOfBoxesTransmitted: numOfBoxesTransmitted,
    numOfBoxesSubmittedToday: numOfBoxesSubmittedToday
  }
}


/**
 * 
 * @param {string} district current district id
 * @param {string} workerId logged in workerid
 * @returns {object} logged user job details 
 */
export const myJobsInfo = async (district, workerId) => {
  const startTodaylocalDateTs = new Date(moment(new Date()).format('YYYY-MM-DD 00:00:00'))
  const endTodaylocalDateTs = new Date(moment(new Date()).format('YYYY-MM-DD 23:59:59'))

  const result = await Promise.all([
    myJob(district, workerId),
    myJobTransmittedToday(district, workerId, startTodaylocalDateTs, endTodaylocalDateTs),
    unAssignedJobs(district)
  ])
  const allMyJob = result[0]
  const transmittedStatusJobs = result[1]
  const unAssignedJobsResults = result[2]

  // const allMyJob = await myJob(district, workerId)
  let dataEntryJobBoxCounts = 0
  let transmittedJobsTodayCount = 0
  let verifyJobBoxCounts = 0
  let totalExceptionBoxesCount = 0
  const dataEntryJobRec = []
  const verifyJobRec = []
  let jobCategory
  let myUser
  const myJobIds = []
  allMyJob.forEach(job => {
    let totBoxForJob = Number(job.data().totalBoxes)
    if (totBoxForJob === totalNoOfBoxesForJob) {
      totBoxForJob = 0
    }

    myUser = job.data().assignedUsers[workerId]
    if (job.data()?.exceptionBoxCount !== undefined) {
      totalExceptionBoxesCount = totalExceptionBoxesCount + job.data()?.exceptionBoxCount
    }
    jobCategory = myUser.jobCategory
    if (jobCategory.length > 0 && jobCategory.indexOf(deJobCategory) > -1) {
      dataEntryJobBoxCounts = dataEntryJobBoxCounts + totBoxForJob
      dataEntryJobRec.push(job)
    } else {
      verifyJobBoxCounts = verifyJobBoxCounts + totBoxForJob
      verifyJobRec.push(job)
    }
    if (job.data().jobStatus === jobStarted) {
      myJobIds.push(job.id)
    }
  })

  if (transmittedStatusJobs.size > 0) {    
    transmittedStatusJobs.forEach(job => {
      transmittedJobsTodayCount++
      myJobIds.push(job.id)
    })
  }

  const myJobIdsHashTable = {}
  for (let i = 0; i < myJobIds.length; ++i) {
    myJobIdsHashTable[myJobIds[i]] = true
  }

  let numOfBoxesSubmittedToday = 0
  const boxResults2 = await allBoxDocsForJob(district, startTodaylocalDateTs, endTodaylocalDateTs)
  boxResults2.forEach(box => {
    if (box.data().status === boxTransmitted && box.data().transmittedTs && myJobIdsHashTable[box.data().jobId]) {
      numOfBoxesSubmittedToday++
    }
  })

  let unAssignedJobsRecords = []
  if (unAssignedJobsResults) {
    unAssignedJobsRecords = unAssignedJobsResults.docs.map(doc => doc.data())
  }

  const myJobDetails = {
    dataEntry: {
      numOfJobs: dataEntryJobRec.length,
      totalBoxes: dataEntryJobBoxCounts
    },
    verification: {
      numOfJobs: verifyJobRec.length,
      totalBoxes: verifyJobBoxCounts
    },
    unAssignedJobs: {
      numOfJobs: unAssignedJobsRecords.length,
      totalBoxes: 0
    },
    exception: {
      numOfJobs: 0,
      totalBoxes: totalExceptionBoxesCount
    },
    transmittedToday: {
      numOfJobs: transmittedJobsTodayCount,
      totalBoxes: numOfBoxesSubmittedToday
    }  
  }
  return myJobDetails
}

export const keyStrokePageInfo = async(district) => {
  const last7Days = await last7BusinessDays(district)
  const seventhDay = last7Days[0]
  const sixthDay = last7Days[1]
  const fifthDay = last7Days[2]
  const fourthDay = last7Days[3]
  const thirdDay = last7Days[4]
  const secondDay = last7Days[5]
  const startDay = last7Days[6]
  const metricsData = await districtMetricsInfo(district, 
    new Date(`${startDay} 00:00:00`), new Date(`${seventhDay} 23:59:59`))
  let totalKeyStroke1stDay = 0
  let totalKeyStroke2ndDay = 0 
  let totalKeyStroke3rdDay = 0
  let totalKeyStroke4thDay = 0
  let totalKeyStroke5thDay = 0
  let totalKeyStroke6thDay = 0
  let totalKeyStroke7thDay = 0
  let totalRecords1stDay = 0
  let totalRecords2ndDay = 0
  let totalRecords3rdDay = 0
  let totalRecords4thDay = 0
  let totalRecords5thDay = 0
  let totalRecords6thDay = 0
  let totalRecords7thDay = 0
  let totalKeyedTime1stDay = 0
  let totalKeyedTime2ndDay = 0
  let totalKeyedTime3rdDay = 0
  let totalKeyedTime4thDay = 0
  let totalKeyedTime5thDay = 0
  let totalKeyedTime6thDay = 0
  let totalKeyedTime7thDay = 0
  let currentKeyStrokeCount = 0
  let currentRecordCount = 0
  let currentKeyedTime = 0
  metricsData.forEach(metrics => {
    const recordDate = moment(metrics.data().createdTs.toDate()).format('YYYY-MM-DD')
    currentKeyStrokeCount = metrics.data().keyStrokeCount === undefined ? 0 : metrics.data().keyStrokeCount
    currentRecordCount = metrics.data().totalRecordCount === undefined ? 0 : metrics.data().totalRecordCount
    currentKeyedTime = metrics.data().keyedTime === undefined ? 0 : metrics.data().keyedTime
    switch (recordDate) {
      case seventhDay:
        totalKeyStroke7thDay = totalKeyStroke7thDay + currentKeyStrokeCount
        totalRecords7thDay = totalRecords7thDay + currentRecordCount
        totalKeyedTime7thDay = totalKeyedTime7thDay + currentKeyedTime
        break
      case sixthDay:
        totalKeyStroke6thDay = totalKeyStroke6thDay + currentKeyStrokeCount
        totalRecords6thDay = totalRecords6thDay + currentRecordCount
        totalKeyedTime6thDay = totalKeyedTime6thDay + currentKeyedTime
        break
      case fifthDay:
        totalKeyStroke5thDay = totalKeyStroke5thDay + currentKeyStrokeCount
        totalRecords5thDay = totalRecords5thDay + currentRecordCount
        totalKeyedTime5thDay = totalKeyedTime5thDay + currentKeyedTime
        break
      case fourthDay:
        totalKeyStroke4thDay = totalKeyStroke4thDay + currentKeyStrokeCount
        totalRecords4thDay = totalRecords4thDay + currentRecordCount
        totalKeyedTime4thDay = totalKeyedTime4thDay + currentKeyedTime
        break
      case thirdDay:
        totalKeyStroke3rdDay = totalKeyStroke3rdDay + currentKeyStrokeCount
        totalRecords3rdDay = totalRecords3rdDay + currentRecordCount
        totalKeyedTime3rdDay = totalKeyedTime3rdDay + currentKeyedTime
        break
      case secondDay:
        totalKeyStroke2ndDay = totalKeyStroke2ndDay + currentKeyStrokeCount
        totalRecords2ndDay = totalRecords2ndDay + currentRecordCount
        totalKeyedTime2ndDay = totalKeyedTime2ndDay + currentKeyedTime
        break
      case startDay:
        totalKeyStroke1stDay = totalKeyStroke1stDay + currentKeyStrokeCount
        totalRecords1stDay = totalRecords1stDay + currentRecordCount
        totalKeyedTime1stDay = totalKeyedTime1stDay + currentKeyedTime
        break
    }
  })
  
  const metricsInfoResult = {
    '1stDay': {
      date: startDay,
      kph: getKph(totalKeyStroke1stDay, totalKeyedTime1stDay),
      filesByDay: totalRecords1stDay
    },
    '2ndDay': {
      date: moment(secondDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke2ndDay, totalKeyedTime2ndDay),
      filesByDay: totalRecords2ndDay
    },
    '3rdDay': {
      date: moment(thirdDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke3rdDay, totalKeyedTime3rdDay),
      filesByDay: totalRecords3rdDay
    },
    '4thDay': {
      date: moment(fourthDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke4thDay, totalKeyedTime4thDay),
      filesByDay: totalRecords4thDay
    },
    '5thDay': {
      date: moment(fifthDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke5thDay, totalKeyedTime5thDay),
      filesByDay: totalRecords5thDay
    },
    '6thDay': {
      date: moment(sixthDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke6thDay, totalKeyedTime6thDay),
      filesByDay: totalRecords6thDay
    },
    '7thDay': {
      date: moment(seventhDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke7thDay, totalKeyedTime7thDay),
      filesByDay: totalRecords7thDay
    }
  }
  return metricsInfoResult
}

export const keyStrokePageInfoForWorker = async(district, workerId) => {
  const last7Days = await last7BusinessDays(district)
  const seventhDay = last7Days[0]
  const sixthDay = last7Days[1]
  const fifthDay = last7Days[2]
  const fourthDay = last7Days[3]
  const thirdDay = last7Days[4]
  const secondDay = last7Days[5]
  const startDay = last7Days[6]
  const metricsData = await districtMetricsInfoByWorker(district, workerId, 
    new Date(`${startDay} 00:00:00`), new Date(`${seventhDay} 00:00:00`))
  let totalKeyStroke1stDay = 0
  let totalKeyStroke2ndDay = 0 
  let totalKeyStroke3rdDay = 0
  let totalKeyStroke4thDay = 0
  let totalKeyStroke5thDay = 0
  let totalKeyStroke6thDay = 0
  let totalKeyStroke7thDay = 0
  let totalRecords1stDay = 0
  let totalRecords2ndDay = 0
  let totalRecords3rdDay = 0
  let totalRecords4thDay = 0
  let totalRecords5thDay = 0
  let totalRecords6thDay = 0
  let totalRecords7thDay = 0
  let totalKeyedTime1stDay = 0
  let totalKeyedTime2ndDay = 0
  let totalKeyedTime3rdDay = 0
  let totalKeyedTime4thDay = 0
  let totalKeyedTime5thDay = 0
  let totalKeyedTime6thDay = 0
  let totalKeyedTime7thDay = 0
  metricsData.forEach(metrics => {
    const recordDate = moment(metrics.data().createdTs.toDate()).format('YYYY-MM-DD')
    switch (recordDate) {
      case seventhDay:
        totalKeyStroke7thDay = totalKeyStroke7thDay + metrics.data().keyStrokeCount
        totalRecords7thDay = totalRecords7thDay + metrics.data().totalRecordCount
        totalKeyedTime7thDay = totalKeyedTime7thDay + metrics.data().keyedTime
        break
      case sixthDay:
        totalKeyStroke6thDay = totalKeyStroke6thDay + metrics.data().keyStrokeCount
        totalRecords6thDay = totalRecords6thDay + metrics.data().totalRecordCount
        totalKeyedTime6thDay = totalKeyedTime6thDay + metrics.data().keyedTime
        break
      case fifthDay:
        totalKeyStroke5thDay = totalKeyStroke5thDay + metrics.data().keyStrokeCount
        totalRecords5thDay = totalRecords5thDay + metrics.data().totalRecordCount
        totalKeyedTime5thDay = totalKeyedTime5thDay + metrics.data().keyedTime
        break
      case fourthDay:
        totalKeyStroke4thDay = totalKeyStroke4thDay + metrics.data().keyStrokeCount
        totalRecords4thDay = totalRecords4thDay + metrics.data().totalRecordCount
        totalKeyedTime4thDay = totalKeyedTime4thDay + metrics.data().keyedTime
        break
      case thirdDay:
        totalKeyStroke3rdDay = totalKeyStroke3rdDay + metrics.data().keyStrokeCount
        totalRecords3rdDay = totalRecords3rdDay + metrics.data().totalRecordCount
        totalKeyedTime3rdDay = totalKeyedTime3rdDay + metrics.data().keyedTime
        break
      case secondDay:
        totalKeyStroke2ndDay = totalKeyStroke2ndDay + metrics.data().keyStrokeCount
        totalRecords2ndDay = totalRecords2ndDay + metrics.data().totalRecordCount
        totalKeyedTime2ndDay = totalKeyedTime2ndDay + metrics.data().keyedTime
        break
      case startDay:
        totalKeyStroke1stDay = totalKeyStroke1stDay + metrics.data().keyStrokeCount
        totalRecords1stDay = totalRecords1stDay + metrics.data().totalRecordCount
        totalKeyedTime1stDay = totalKeyedTime1stDay + metrics.data().keyedTime
        break
    }
  })

  const metricsInfoResult = {
    '1stDay': {
      date: startDay,
      kph: getKph(totalKeyStroke1stDay, totalKeyedTime1stDay),
      filesByDay: totalRecords1stDay
    },
    '2ndDay': {
      date: moment(secondDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke2ndDay, totalKeyedTime2ndDay),
      filesByDay: totalRecords2ndDay
    },
    '3rdDay': {
      date: moment(thirdDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke3rdDay, totalKeyedTime3rdDay),
      filesByDay: totalRecords3rdDay
    },
    '4thDay': {
      date: moment(fourthDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke4thDay, totalKeyedTime4thDay),
      filesByDay: totalRecords4thDay
    },
    '5thDay': {
      date: moment(fifthDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke5thDay, totalKeyedTime5thDay),
      filesByDay: totalRecords5thDay
    },
    '6thDay': {
      date: moment(sixthDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke6thDay, totalKeyedTime6thDay),
      filesByDay: totalRecords6thDay
    },
    '7thDay': {
      date: moment(seventhDay).format('YYYY-MM-DD'),
      kph: getKph(totalKeyStroke7thDay, totalKeyedTime7thDay),
      filesByDay: totalRecords7thDay
    }
  }
  return metricsInfoResult
}

/**
 * 
 * @param {number} totalKeyStroke total keystroke
 * @param {number} totalTimeInSec total time in seconds
 * @returns {number} kph value
 */
export function getKph(totalKeyStroke, totalTimeInSec) {
  let timeInHours = 0
  if (totalKeyStroke > 0 && totalTimeInSec > 0) {
    timeInHours = totalTimeInSec / 3600
    return roundNumber(totalKeyStroke / timeInHours)
  }
  return 0
}